import { render } from "./list-notification-client.vue?vue&type=template&id=1cf5d3fc"
import script from "./list-notification-client.vue?vue&type=script&lang=js"
export * from "./list-notification-client.vue?vue&type=script&lang=js"

import "./list-notification-client.vue?vue&type=style&index=0&id=1cf5d3fc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__